
export const releaseStates = {
  marked_for_release: "Ready",
  in_progress: "In Progress",
  released: "Released",
  failed: "Failed",
  not_marked: "Not Ready",
  signed_off: "Signed Off"
};
  
